// extracted by mini-css-extract-plugin
export default {"how_much_does_it_cost":"HowMuchDoesItCost_how_much_does_it_cost__yi1b8","how_much_does_it_cost_img":"HowMuchDoesItCost_how_much_does_it_cost_img__HcL3r"};